document.addEventListener('turbolinks:load', function() {
    const skillcardModal = document.getElementById('skillcardModal');
    if (skillcardModal) {
      skillcardModal.addEventListener('show.bs.modal', function (event) {
        const button = event.relatedTarget;
        const employeeId = button.getAttribute('data-employee-id');
        const modalBody = skillcardModal.querySelector('.modal-body');
        
        // Fetch the skillcard content
        fetch(`/employees/${employeeId}/skillcard`)
          .then(response => response.text())
          .then(html => {
            modalBody.innerHTML = html;
          })
          .catch(error => {
            console.error('Error:', error);
            modalBody.innerHTML = 'Er is een fout opgetreden bij het laden van de skillcard.';
          });
      });
    }
});